var _createReducer;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { produce } from 'immer';
import { ActionsTypes } from './Editor.actions';
import { EDITOR_STEPS, EDITOR_TOOLS, STORAGE } from '../constants';

function createReducer(initialState, handlers) {
  return function reducer(state, action) {
    if (state === void 0) {
      state = initialState;
    }

    if (handlers === null || handlers === void 0 ? void 0 : handlers.hasOwnProperty(action.type)) {
      return produce(state, function (draft) {
        return handlers[action.type](draft, action);
      });
    } else {
      return state;
    }
  };
}

export var initialState = {
  authToken: localStorage.getItem(STORAGE.authToken),
  uploadedFile: '',
  uploadedPdfDocument: '',
  forceRasterization: false,
  pdfDocument: null,
  editedUrl: null,
  downloadUrl: null,
  mounted: false,
  tools: true,
  thumbnail: true,
  activeTool: EDITOR_TOOLS.text,
  activeStep: EDITOR_STEPS.edit,
  activeColor: '#000000',
  changes: {
    past: [],
    present: [],
    future: []
  },
  processing: false
};
var editorReducer = createReducer(initialState, (_createReducer = {}, _createReducer[ActionsTypes.START_SESSION] = function (state, _ref) {
  var _ref$payload = _ref.payload,
      uploadedFile = _ref$payload.uploadedFile,
      uploadedPdfDocument = _ref$payload.uploadedPdfDocument;
  return _extends({}, initialState, {
    uploadedFile: uploadedFile,
    uploadedPdfDocument: uploadedPdfDocument
  });
}, _createReducer[ActionsTypes.SET_DOCUMENT] = function (state, _ref2) {
  var pdfDocument = _ref2.payload.pdfDocument;
  state.pdfDocument = pdfDocument;
}, _createReducer[ActionsTypes.SET_MOUNTED] = function (state) {
  state.mounted = true;
}, _createReducer[ActionsTypes.RESET_SESSION] = function () {
  return _extends({}, initialState);
}, _createReducer[ActionsTypes.SET_ACTIVE_TOOL] = function (state, _ref3) {
  var activeTool = _ref3.payload.activeTool;
  state.activeTool = activeTool;
}, _createReducer[ActionsTypes.SET_ACTIVE_COLOR] = function (state, _ref4) {
  var activeColor = _ref4.payload.activeColor;
  state.activeColor = activeColor;
}, _createReducer[ActionsTypes.SET_PROCESSING] = function (state, _ref5) {
  var processing = _ref5.payload.processing;
  state.mounted = false;
  state.editedUrl = null;
  state.processing = processing;
}, _createReducer[ActionsTypes.SET_REDACT_STEP] = function (state) {
  state.editedUrl = null;
  state.activeTool = EDITOR_TOOLS.text;
  state.tools = true;
  state.pdfDocument = null;
  state.mounted = false;
  state.forceRasterization = false;
  state.activeStep = EDITOR_STEPS.edit;
}, _createReducer[ActionsTypes.SET_REVIEW_STEP] = function (state, _ref6) {
  var _ref6$payload = _ref6.payload,
      url = _ref6$payload.url,
      _ref6$payload$forceRa = _ref6$payload.forceRasterization,
      forceRasterization = _ref6$payload$forceRa === void 0 ? false : _ref6$payload$forceRa;
  state.editedUrl = url;
  state.activeTool = null;
  state.tools = false;
  state.pdfDocument = null;
  state.mounted = false;
  state.forceRasterization = forceRasterization;
  state.activeStep = EDITOR_STEPS.review;
}, _createReducer[ActionsTypes.SET_FINISH_STEP] = function (state, _ref7) {
  var url = _ref7.payload.url;
  state.editedUrl = null;
  state.downloadUrl = url;
  state.activeTool = EDITOR_TOOLS.text;
  state.tools = true;
  state.pdfDocument = null;
  state.mounted = false;
  state.forceRasterization = false;
  state.activeStep = EDITOR_STEPS.edit;
}, _createReducer[ActionsTypes.ADD_CHANGES] = function (state, _ref8) {
  var changes = _ref8.payload.changes;
  var _state$changes = state.changes,
      past = _state$changes.past,
      present = _state$changes.present;
  state.changes = {
    past: [].concat(past, [present]),
    present: [].concat(present, [changes]),
    future: []
  };
}, _createReducer[ActionsTypes.UPDATE_CHANGES] = function (state, _ref9) {
  var _ref9$payload = _ref9.payload,
      changes = _ref9$payload.changes,
      id = _ref9$payload.id;
  var _state$changes2 = state.changes,
      past = _state$changes2.past,
      present = _state$changes2.present;
  var index = present.findIndex(function (p) {
    return p.id === id;
  });
  var currentChange = present[index];

  var newChange = _extends({}, currentChange, {
    position: _extends({}, currentChange.position, changes.position),
    content: _extends({}, currentChange.content, changes.content)
  });

  var cloned = JSON.parse(JSON.stringify(present));
  cloned[index] = newChange;
  state.changes = {
    past: [].concat(past, [present]),
    present: cloned,
    future: []
  };
}, _createReducer[ActionsTypes.UNDO_CHANGES] = function (state) {
  var _state$changes3 = state.changes,
      past = _state$changes3.past,
      present = _state$changes3.present,
      future = _state$changes3.future;
  state.changes.present = past[past.length - 1];
  state.changes.past = past.slice(0, past.length - 1);
  state.changes.future = [present].concat(future);
}, _createReducer[ActionsTypes.REDO_CHANGES] = function (state) {
  var _state$changes4 = state.changes,
      past = _state$changes4.past,
      present = _state$changes4.present,
      future = _state$changes4.future;
  state.changes.present = future[0];
  state.changes.past = [].concat(past, [present]);
  state.changes.future = future.slice(1);
}, _createReducer[ActionsTypes.CLEAR_CHANGES] = function (state) {
  var present = state.changes.present;
  state.changes.past.push(present);
  state.changes.present = [];
  state.changes.future = [];
}, _createReducer[ActionsTypes.UPDATE_STORE] = function (state, _ref10) {
  var payload = _ref10.payload;
  return _extends({}, state, payload);
}, _createReducer));
export default editorReducer;